export default __webpack_public_path__ + "static/media/purple.174142d5.svg";